import type { App } from "../Entity/App";

/**
 * AppStack — registre des instances App chargées (extrait de WebPage, ha/443d).
 *
 * Possède la Map `apps` (id → App). WebPage y délègue add/get/remove/clear et
 * l'itération (clean). L'orchestration navigation (showPrevious, notifyAppInfo,
 * getAppService().removeApp) reste dans WebPage : AppStack ne connaît que le
 * registre, pas l'historique ni le cycle de vue. Comportement strictement
 * identique au God-object d'origine (mêmes opérations Map).
 */
export class AppStack {
    private readonly apps = new Map<string, App>();

    public add(app: App): void {
        // ha/508 — Clé d'instance (`_id` composite si nav paramétrée, sinon
        // pageId) : deux records d'une même page détail ne collisionnent plus.
        this.apps.set(app.getStackKey(), app);
    }

    public get(id: string): App | undefined {
        return this.apps.get(id);
    }

    public delete(id: string): void {
        this.apps.delete(id);
    }

    public clear(): void {
        this.apps.clear();
    }

    public forEach(cb: (app: App, id: string) => void): void {
        this.apps.forEach(cb);
    }

    public size(): number {
        return this.apps.size;
    }
}
